// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadas_DeleteScheduledMessageInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /mensagens_programadas/deleteScheduledMessage
 *
 * Cancels a scheduled message.
 */
import { registerContract } from './validate'

export interface MensagensProgramadas_DeleteScheduledMessageInput {
mensagem_programada_id: number
}

registerContract('MensagensProgramadas_DeleteScheduledMessageInput', {
  mensagem_programada_id: { type: 'number',  required: true },
})
